export default class GenericTracker {
    constructor () {}

    track(event: any) {}
}